import { useMemo } from 'react';

import { useProducts } from './useProducts';

const useProductVariant = (productVariantId: string) => {
  const { getProductVariantById } = useProducts();

  const productVariant = useMemo(() => {
    const variant = getProductVariantById(productVariantId);

    if (!variant) {
      throw new Error(`Product variant with id ${productVariantId} not found`);
    }

    return variant;
  }, [getProductVariantById, productVariantId]);

  const sellingPlanAllocations = useMemo(
    () => productVariant.sellingPlanAllocations.nodes,
    [productVariant.sellingPlanAllocations.nodes],
  );

  return {
    sellingPlanAllocations,
    productVariant,
  };
};

export { useProductVariant };
